import { render, staticRenderFns } from "./PackageCheckout.vue?vue&type=template&id=33fa96c7&scoped=true"
import script from "./PackageCheckout.vue?vue&type=script&lang=ts"
export * from "./PackageCheckout.vue?vue&type=script&lang=ts"
import style0 from "./PackageCheckout.vue?vue&type=style&index=0&id=33fa96c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fa96c7",
  null
  
)

export default component.exports